module.exports = __webpack_public_path__ + "media/application/images/logo-c970b0ae764c66b54362610c3419a227.png";